import * as React from "react";

import { cn } from "./utils";

function Input({ className, type, max, ...props }: React.ComponentProps<"input">) {
  // Get today's date in YYYY-MM-DD format for date inputs
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Automatically set max to today for date inputs if max is not explicitly provided
  // If max is explicitly set to null or empty string, allow all dates (no max restriction)
  // If max is undefined (not provided), default to today
  const dateMax = type === 'date' 
    ? (max === null || max === '' ? undefined : (max || getTodayDate()))
    : max;

  return (
    <input
      type={type}
      data-slot="input"
      max={dateMax}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base bg-input-background transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
